export default __webpack_public_path__ + "static/image02-6175b5977fedd67695602dd8c11b03db.jpg";